<div class="landing-ad-container landing-ad-main" *ngIf="!isNfr && baseAd">
    <a (click)="sendAdPromotionClick(baseAd)" [href]="baseAd.adLink" class="landing-ad" [class]="baseAd.type"
       [attr.data-promo]="baseAd.name">
        <picture *ngIf="!!heroAdDesktopUrl || !!heroAdMobileUrl">
            <source media="(max-width: {{viewSizeMobile}}px)"
                    srcset="{{heroAdMobileUrl}}">
            <source srcset="{{heroAdDesktopUrl}}">
            <img class="img-fluid mx-auto"
                 src="{{heroAdDesktopUrl}}" alt=""/>
        </picture>

        <div class='image-title-description'>
            <h1 class="heading-3">{{ titleText ? titleText : baseAd.imageTitle }}</h1>
            <p data-automation="landing-ad-hero-description">{{ messageText ? messageText : baseAd.imageDescription }}</p>
        </div>
    </a>
</div>
